// Entry for the server-rendered landing page. Vue islands load only when their
// placeholder nears the viewport, so the Vue runtime stays off the critical path.
const calculator = document.getElementById('savings-calculator');

async function mountCalculator(el: HTMLElement) {
    const [{ createApp }, { default: SavingsCalculator }] = await Promise.all([
        import('vue'),
        import('@/Components/Landing/SavingsCalculator/SavingsCalculator.vue'),
    ]);
    createApp(SavingsCalculator).mount(el);
    // Release the space the Blade placeholder reserved to avoid a layout shift.
    el.classList.remove(
        ...(el.dataset.reservedHeight ?? '').split(' ').filter(Boolean)
    );
}

if (calculator) {
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    observer.disconnect();
                    void mountCalculator(calculator);
                }
            },
            { rootMargin: '600px 0px' }
        );
        observer.observe(calculator);
    } else {
        void mountCalculator(calculator);
    }
}
